<nb-card [nbSpinner]="isSpinnerActive" nbSpinnerStatus="warning">
  <nb-card-header class="d-flex justify-content-between">
    <div class="d-flex">
      Tichete conta <b class="ml-1" *ngIf="clientId">{{client?.client_name}}</b>
      <div class="income-header-right" *ngIf="clientId">
        <button nbButton class="ml-2 mr-2" size="small" status="info" (click)="createTicket()">
          <nb-icon class="action-icon text-white" icon="plus-circle-outline"></nb-icon>
          Tichet nou
        </button>
      </div>
      <nb-toggle class="ml-3" 
        [(checked)]="areOlderTicketsVisible" 
        (checkedChange)="onToggleOlderTickets($event)">
      <span class="ml-2">Afișare doar recente (3 luni)</span>
      </nb-toggle>
    </div>
    <div>
      <button nbButton status="danger" (click)="dismiss(null)" title="Închide"><nb-icon
          icon="close-outline"></nb-icon></button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <virtual-scroller #scroll [useMarginInsteadOfTranslate]="true" [items]="filteredTickets" [stripedTable]="true" *ngIf="!isSpinnerActive" [checkResizeInterval]="0"
      [enableUnequalChildrenSizes]="true" [scrollAnimationTime]="0">
      <table class="table table-striped">
        <thead class="bg-white" #header>
          <tr>
            <th *ngFor="let column of columns" [ngClass]="column.class" [attr.colspan]="column.colspan"
              (click)="sortTickets(column, false)">
              <ng-container *ngIf="column.checkbox">
                <nb-checkbox (checkedChange)="toggleAll()" class="mr-2"></nb-checkbox>
              </ng-container>
              {{column.name}}
              <nb-icon *ngIf="column.order === 'asc'" class="action-icon text-black"
                icon="arrow-downward-outline"></nb-icon>
              <nb-icon *ngIf="column.order === 'desc'" class="action-icon text-black"
                icon="arrow-upward-outline"></nb-icon>
              <div *ngIf="column.hasFilter && column.hasChildren" style="display: inline">
                <nb-select class="col-12 mr-2 yes-no-selector" size="tiny" placeholder="Filtru"
                  (selectedChange)="column.filterFunction($event)">
                  <nb-option value="">Toate</nb-option>
                  <nb-option *ngFor="let option of column?.filterOptionsKeys" [value]="option">
                    {{ column?.filterOptions[option] }}
                  </nb-option>
                </nb-select>
              </div>

              <div *ngIf="column.hasChildren" style="display: flex;">
                <span *ngFor="let children of column.children" [ngClass]="children.class">
                  {{ children.name }}
                </span>
              </div>
            </th>
          </tr>

          <tr>
            <th *ngFor="let column of columns" [ngClass]="column.class" [attr.colspan]="column.colspan">
              <div *ngIf="column.hasChildren" style="display: flex;">
                <span *ngFor="let children of column.children" [ngClass]="children.class">
                  <div *ngIf="children.hasFilter">
                    <nb-select class="col-12 mr-2 yes-no-selector" size="tiny" placeholder="Filtru" #mySelect
                      (selectedChange)="children.filterFunction($event)">
                      <nb-option value="">Toate</nb-option>
                      <nb-option *ngFor="let option of children.filterOptionsKeys" [value]="option"
                        [innerHtml]="children.filterOptions[option]"></nb-option>
                    </nb-select>
                  </div>
                </span>
              </div>
              <div *ngIf="!column.hasChildren">
                <div *ngIf="column.hasFilter">
                  <nb-select class="col-12 mr-2 yes-no-selector" size="tiny" placeholder="Filtru" #mySelect
                    (selectedChange)="column.filterFunction($event)">
                    <nb-option value="">Toate</nb-option>
                    <nb-option *ngFor="let option of column.filterOptionsKeys" [value]="option"
                      [innerHtml]="column.filterOptions[option]"></nb-option>
                  </nb-select>
                </div>
              </div>
            </th>
          </tr>
        </thead>

              <tbody #container>
                  <tr *ngFor="let ticket of scroll.viewPortItems"
                      [class.status-open]="ticket.status == ticketStatuses.open"
                      [class.status-sent]="ticket.status == ticketStatuses.sent"
                      [class.status-closed]="ticket.status == ticketStatuses.closed || (ticket.status == ticketStatuses.solving && ticket.toUserId == userId)"
                  >
                      <td class="ticket-action">
                        <button nbButton size="small" ghost status="danger" title="Problemă repetitivă"
                                *ngIf="ticket.repetitiveIssue !== 'true'"
                                (click)="markAsRepetitiveIssue(ticket)">
                          <nb-icon icon="alert-circle-outline"></nb-icon>
                        </button>
                        <button nbButton size="small" ghost status="info"
                                *ngIf="ticket.status != ticketStatuses.closed"
                                title="Închide tichet" (click)="closeIssue(ticket)">
                          <nb-icon icon="checkmark-outline"></nb-icon>
                        </button>
                      </td>
                      <td class="ticket-number" (click)="!ticket.isItTicket && editDetail(ticket)">
                        #{{ ticket.id }}
                      </td>
                      <td class="ticket-date" (click)="editDetail(ticket)" *asconLet="userFromStore(ticket?.userId) | async as user">
                        {{ (user?.user_firstname || '') + ' ' + (user?.user_lastname || '') }} {{ ticket?.userId === '0' && ticket?.issuer !== '' ? 'Client' : '' }}
                      </td>
                      <td class="ticket-user" (click)="editDetail(ticket)">
                        <ng-container *ngIf="ticket?.category && departments.includes(ticket?.category); else showUser">
                          <span class="dept-badge" [ngClass]="{
                                                                          'dept-it': ticket?.category === 'IT',
                                                                          'dept-hr': ticket?.category === 'HR',
                                                                          'dept-juridic': ticket?.category === 'JURIDIC',
                                                                          'dept-fonduri': ticket?.category === 'FONDURI EU',
                                                                          'dept-conta': ticket?.category === 'CONTABILITATE'
                                                                        }">{{ ticket?.category }}</span>
                        </ng-container>
                        <ng-template #showUser>
                          <ng-container *asconLet="userFromStore(ticket?.toUserId) | async as user">
                            {{ (user?.user_firstname || '') + ' ' + (user?.user_lastname || '') }}
                          </ng-container>
                        </ng-template>
                      </td>
                      <td class="ticket-date" (click)="editDetail(ticket)">
                        {{ ticket.day | date: 'dd.MM.yyyy' }}
                      </td>
                      <td class="ticket-issue" (click)="editDetail(ticket)" [innerHTML]="ticket?.firstMessage"></td>
                      <td class="ticket-severity" (click)="editDetail(ticket)">
                        <span
                          [class.severity-low]="ticket.severity == ticketSeverity.low"
                          [class.severity-medium]="ticket.severity == ticketSeverity.medium"
                          [class.severity-high]="ticket.severity == ticketSeverity.high"
                        >
                          {{ ticketSeverityLabel[ticket.severity] }}
                        </span>
                      </td>
                      <td class="ticket-severity" (click)="editDetail(ticket)">
                          {{ ticketStatusLabel[ticket.status] }}
                      </td>
                  </tr>
              </tbody>
          </table>
        </virtual-scroller>
    </nb-card-body>
</nb-card>